/*
MIT License

Copyright (c) 2020 THW / webgis
Author: Raphael Baumann
Files: tactical-sign-operator.js and tactical-sign-operator.css

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/

(function(factory, window) {
  if (typeof define === "function" && define.amd) {
    define(["leaflet"], factory)
  } else if (typeof exports === "object") {
    module.exports = factory(require("leaflet"))
  }
  if (typeof window !== "undefined" && window.L) {
    window.L.Control.TacticalSign = factory(L);
    window.L.control.tacticalSign = function(options) {
      return new window.L.Control.TacticalSign(options)
    }
  }
})(function(L) {
  var TacticalSign = L.Control.extend({
    options: {
      position: 'topright',
      ControlLabel: '&#x1F4D7;', //unicode Tabelle
      ControlClasses: [],
      ControlTitle: 'Get Icon',
      _unicodeClass: 'unicode-icon-enable',
      inputTitle: 'Click on Item to Choose it!',

      windowMaxWith: '50vw',
      windowsMaxHeight: '20vh',

      rootOverLayer: '',
      nameOfLayer: 'Taktische-Zeichen',
    },

    onAdd: function(map) {
      this._map = map;

      this.points = new L.layerGroup([]);

      if (!(Object.keys(this.options.rootOverLayer).includes("Points"))) {
        this.options.rootOverLayer["Points"] = {};
      }

      this.options.rootOverLayer.Points[this.options.nameOfLayer] = this.points;

      const title = this.options.ControlTitle;
      const label = this.options.ControlLabel;
      let classes = this.options.ControlClasses;

      if (label.indexOf('&') != -1) classes.push(this.options._unicodeClass);

      return this._createControl(label, title, classes, this._click, this);
    },

    _click: function(e) {
      this._map.dragging.disable();
      this._map.dragging.disable();
      this._map.touchZoom.disable();
      this._map.doubleClickZoom.disable();
      this._map.scrollWheelZoom.disable();
      this._map.boxZoom.disable();
      this._map.keyboard.disable();
      if (this._map.tap) this._map.tap.disable();

      this._container.classList.add('leaflet-control-layers-expanded');
      this._containerParams.style.display = '';
      this._controlPanel.classList.add('unicode-icon-disable');
    },

    _createControl: function(label, title, classesToAdd, fn, context) {

      this._container = document.createElement('div');
      this._container.id = 'print-container';
      this._container.overflow = 'hidden';
      this._container.classList.add('leaflet-bar');
      this._containerParams = document.createElement('div');
      this._containerParams.id = 'params';
      this._containerParams.style.display = 'none';


      let containerTitle = document.createElement('h2');
      containerTitle.style.width = '100%';
      containerTitle.innerHTML = this.options.inputTitle;
      this._containerParams.appendChild(containerTitle);

      this._createCloseButton();
      this._createSigns();
      this._createControlPanel(classesToAdd, context, label, title, fn);


      this._container.appendChild(this._containerParams);
      return this._container;
    },

    _createControlPanel: function(classesToAdd, context, label, title, fn) {
      let controlPanel = document.createElement('a');
      controlPanel.innerHTML = label;
      controlPanel.id = 'btn';
      controlPanel.setAttribute('title', title);
      classesToAdd.forEach(function(c) {
        controlPanel.classList.add(c);
      });
      L.DomEvent.on(controlPanel, 'click', fn, context);
      this._container.appendChild(controlPanel);
      this._controlPanel = controlPanel;
    },


    _createCloseButton: function() {
      let span = document.createElement('div');
      span.classList.add('close');
      span.innerHTML = '&times;';

      span.addEventListener('click', () => {
        this._map.dragging.enable();
        this._map.dragging.enable();
        this._map.touchZoom.enable();
        this._map.doubleClickZoom.enable();
        this._map.scrollWheelZoom.enable();
        this._map.boxZoom.enable();
        this._map.keyboard.enable();
        if (this._map.tap) this._map.tap.enable();

        this._container.classList.remove('leaflet-control-layers-expanded');
        this._containerParams.style.display = 'none';
        this._controlPanel.classList.remove('unicode-icon-disable');
      });

      this._containerParams.appendChild(span);
    },

    _importall: function(tst) {
      return tst.keys().map(tst);
    },


    _createSigns: function(fn) {
      var directory = "svg";
      // slightly modified to serve the images from the assets folder -- meier_ul, 2021-01-02
      var path = this._importall(require.context('@/assets/Taktische-Zeichen/svg', true));
      var someObject = require('@/assets/Taktische-Zeichen/Taktische-Zeichen-svg-List.json');


      const outer = document.createElement('div');
      outer.style.overflow = 'auto'; // forcing scrollbar to appear
      outer.style.width = 'auto';
      outer.style.height = 'auto';
      outer.style.maxWidth = this.options.windowMaxWith;
      outer.style.maxHeight = this.options.windowsMaxHeight;
      outer.style.textAlign = "center";
      this._containerParams.appendChild(outer);



      var basefolder = [];
      var subtitle = [];

      var subfolder = someObject.Folders[0];
      var subcounter = 0;
      var counter = subfolder[1];

      for (var j = 0; j < someObject.Folders.length; j++) {
        subtitle = document.createElement('h3');
        subtitle.style.width = '100%';
        subtitle.type = 'utf-8';
        subtitle.innerHTML = subfolder[0];
        outer.appendChild(subtitle);

        for (var i = subcounter; i < counter; i++) {
          var img = document.createElement('img');
          img.src = path[i];
          img.name = 'imgcont';
          img.style.width = "3vw"; //3vw
          img.style.height = "3vw";


          basefolder = path[i].split('/')[3].split('.svg');
          subtitle = document.createElement('figcaption');
          subtitle.style.width = '100%';
          subtitle.type = 'utf-8';
          subtitle.innerHTML = basefolder[0].substr(0, (basefolder[0].length-9));

          var figure = document.createElement('figure');
          figure.style.display = 'inline-block';
          figure.style.margin = '20px';
          figure.appendChild(img);
          figure.appendChild(subtitle);
          outer.appendChild(figure);
        }
        if ((j +1) < someObject.Folders.length) {
          subfolder = someObject.Folders[j + 1];
          subcounter = counter;
          counter = counter + subfolder[1];
        }
      }

      var listener = this._containerParams.addEventListener('click', () => {
        var target = event.target;
        if ((target.name != undefined) && (target.name === 'imgcont')) {
          this._map.dragging.enable();
          this._map.dragging.enable();
          this._map.touchZoom.enable();
          this._map.doubleClickZoom.enable();
          this._map.scrollWheelZoom.enable();
          this._map.boxZoom.enable();
          this._map.keyboard.enable();
          if (this._map.tap) this._map.tap.enable();

          this._container.classList.remove('leaflet-control-layers-expanded');
          this._containerParams.style.display = 'none';
          this._controlPanel.classList.remove('unicode-icon-disable');
          this.points.addTo(this._map);

          var LeafIcon = L.Icon.extend({
            options: {
              iconUrl: target.src,
              iconSize: [50, 50],
              iconAnchor: [25, 25],
              popupAnchor: [0, 50]
            }
          });

          basefolder = target.src.split('/');
          basefolder = basefolder[5].split('.');

          var tmpMarker = new L.marker([0, 0], {
            icon: new LeafIcon({})
          }).bindTooltip(decodeURIComponent(basefolder[0]), {
            direction: "top"
          }).addTo(this.points);

          var enable = 1;
          this._map.on({
            mousemove: function(e) {
              if (enable == 1) tmpMarker.setLatLng([e.latlng.lat, e.latlng.lng]);
              tmpMarker.on({
                click: function(e) {
                  enable = 0;
                }
              }, this);
            }
          }, this);
        }


      });
    },

  });



  return TacticalSign;
}, window);
